import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/consortiums', request, cancelToken)
}

export {get}
